export default __webpack_public_path__ + "static/Logo_light-7b0c990fb658b18b1987556ddd4d5895.svg";